const contentSlider = new Swiper('.product-feature-slideshow  .slideshow-content', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  allowTouchMove: true,
  speed: 500,
  watchSlidesProgress: true,
  touchEventsTarget: 'wrapper',
  pagination: {
    el: '.product-feature-slideshow .swiper-pagination',
    clickable: true
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 5000,
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
    }
  }
});

const imageSlider = new Swiper('.product-feature-slideshow .slideshow-images', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 0,
  allowTouchMove: false,
  speed: 500,
  watchSlidesProgress: true,
  effect: 'fade',
  touchEventsTarget: 'wrapper',
  fadeEffect: {
    crossFade: true
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
    }
  }
});

// const cardsSlider = new Swiper('.product-feature-slideshow  .slideshow-cards', {
//   slidesPerView: 1,
//   loop: true,
//   spaceBetween: 0,
//   allowTouchMove: true,
//   speed: 500,
//   watchSlidesProgress: true,
// });

// Sync sliders
// imageSlider.on('slideChange', slider => {
//   let idx = slider.realIndex;

//   contentSlider.slideToLoop(idx);
//   cardsSlider.slideToLoop(idx);
// });

// contentSlider.on('slideChange', slider => {
//   let idx = slider.realIndex;

//   imageSlider.slideToLoop(idx);
//   cardsSlider.slideToLoop(idx);
// });

// cardsSlider.on('slideChange', slider => {
//   let idx = slider.realIndex;

//   imageSlider.slideToLoop(idx);
//   contentSlider.slideToLoop(idx);
// });

imageSlider.controller.control = contentSlider;
contentSlider.controller.control = imageSlider;
